module["exports"] = [
  "주식회사",
  "한국"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/ko/company/prefix.js
 ** module id = 736
 ** module chunks = 0
 **/